import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { ModalService } from 'src/app/services/modal/modal.service';
import { RoleService } from 'src/app/services/role/role.service';
import { Filtres } from 'src/app/utils/interfaces/new/filtres.interface';
import { Role } from 'src/app/utils/interfaces/new/role.interface';

@Component({
  selector: 'app-role-management',
  templateUrl: './role-management.component.html',
  styleUrls: ['./role-management.component.scss']
})
export class RoleManagementComponent implements OnInit {

  public roleColumnTable = [
    { title: 'Nom du rôle', data: 'nom' },
    { title: 'Effacer', data: null },
    { title: 'Modifier', data: null }
  ];
  public rolesPaginated = {
    perpage: -1,
    page: 1,
    total: 8,
    objects: []
  };
  public filtre: Filtres = {
    perpage: 8,
    currentPage: 1
  };

  constructor(
    private rolesSvc: RoleService,
    private router: Router,
    private modalService: ModalService,
    private _viewRef: ViewContainerRef,
  ) { }

  ngOnInit(): void {
    this.initData();
  }

  private async initData(): Promise<void> {
    this.rolesPaginated = await this.rolesSvc.find(this.filtre);
    const roles = this.rolesPaginated.objects;
    this.rolesPaginated.objects = [];
    roles.forEach(role => {
      if (role.disabled) {
        Object.defineProperty(role, 'cantDelete', { value: true });
      }
      this.rolesPaginated.objects.push(role);
    });
  }

  public async delete(role: Role): Promise<void> {
    const modal = this.modalService.openModalConfirmation(this._viewRef, 'Confirmation', 'Voulez-vous vraiment supprimer ce rôle ?');
    modal.instance.closeEmitter.subscribe(async (res: boolean) => {
      if (res) {
        const loadingModal = this.modalService.openLoading(this._viewRef);
        try {
          await this.rolesSvc.delete(role);
          await this.initData();
          this.modalService.close(loadingModal);
        } catch (e) {
          this.modalService.close(loadingModal);
          console.error(e);
        }
      }
    });
  }

  public async onSort(event: any): Promise<void> {
    this.filtre.currentPage = 1;
    this.filtre.sortOrder = event.sortOrder;
    this.filtre.sortBy = event.sortBy;
    this.initData();
  }

  public async onSearch(event: any): Promise<void> {
    this.filtre.currentPage = 1;
    this.filtre.find = event;
    this.initData();
  }

  public async onChangePage(value: any): Promise<void> {
    this.filtre.currentPage = value;
    this.initData();
  }

  public edit(role: Role): void {
    this.router.navigate([`administration/create-role/${role.id}`]);
  }

  public navigateToCreateProfile(): void {
    this.router.navigate(['administration/create-role']);
  }

  private adminPage(): void {
    this.router.navigate(['administration/']);
  }
}
